<template>
  <div style="margin-top:2rem;">
    <div class="form__group field">
      <b-form-input class="form__field" type="text" id="firstName" name="firstName" required
        v-model="localContact.firstName" placeholder="Vorname" />
      <label for="firstName" class="form__label">Vorname *</label>
    </div>

    <div class="form__group field">
      <b-form-input class="form__field" type="text" id="lastName" name="lastName" required v-model="localContact.lastName"
        placeholder="Nachname" />
      <label for="lastName" class="form__label">Nachname *</label>
    </div>

    <div class="form__group field">
      <b-form-input class="form__field" type="text" id="company" name="company" placeholder="Firma/Einrichtung" v-model="localContact.company" />
      <label for="company" class="form__label">Firma/Einrichtung</label>
    </div>

    <div class="form__group field">
      <b-form-input class="form__field" type="email" id="email" name="email" placeholder="Email" required v-model="localContact.email" />
      <label for="email" class="form__label">Email *</label>
    </div>

    <div class="form__group field">
      <b-form-input class="form__field" type="tel" id="phone" name="phone" placeholder="+49..." v-model="localContact.phone" />
      <label for="phone" class="form__label">Telefon</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contact"],
  data() {
    return {
      localContact: Object.assign(
        {
          firstName: "",
          lastName: "",
          gender: "",
          company: "",
          email: "",
          phone: ""
        },
        this.contact
      )
    };
  },
  watch: {
    localContact: {
      handler(value) {
        this.$emit("update:contact", value);
      },
      deep: true
    }
  }
};
</script>
